import { styled } from '@mui/system';
import { theme } from 'oems/theme';
import { Stack as StackMUI } from '@mui/material';
import { Grid as GridMui } from '@mui/material';

export const h3 = styled('h3')`
  font-family: 'Roboto';
  font-style: normal;
  font-weight: 700;
  text-align: left;
  height: 100%;
  font-size: 14px;

  display: flex;
  color: ${({ theme }) => theme.palette.text.dark};
`;

export const h4 = styled('h4')`
  margin-right: 0px;
  padding: 0px;
  font-family: 'Roboto';
  font-style: normal;
  font-weight: 400;
  font-size: 14px;
  vertical-align: bottom;
  line-height: 17.5%;
  color: ${({ theme }) => theme.palette.text.dark};
`;

export const h2 = styled('h2')`
  font-family: 'Roboto';
  font-style: normal;
  font-weight: 700;
  font-size: 24px;
  text-align: center;
  vertical-align: center;
  color: ${({ theme }) => theme.palette.text.dark};
`;

export const h5 = styled('h5')`
  font-family: 'Roboto';
  font-style: normal;
  font-weight: 400;
  font-size: 16px;
  text-align: center;
  vertical-align: center;
  color: ${({ theme }) => theme.palette.text.main};
`;
export const h6 = styled('h6')`
  font-family: 'Roboto';
  font-style: normal;
  font-weight: 400;
  font-size: 13px;
  text-align: left;
  vertical-align: center;
  color: ${({ theme }) => theme.palette.text.main};
`;

export const Stack = styled(StackMUI)`
  justify-content: center;
  height: 30px;
  margin-top: 20px;
`;

export const Grid = styled(GridMui)`
  padding-left: 20px;
`;

export const TitleBox = styled(StackMUI)`
  margin-top: 50px;
  margin-bottom: 20px;
`;
